export type ErrorDetail = {
    errorType: number;
    errorMessage: string;
    errorData?: any;
    source?: string;
};

class DetailedError extends Error {
    detail: ErrorDetail;

    constructor(detail: ErrorDetail) {
        super();
        this.detail = detail;
    }
}

export default DetailedError;
